export default "__VITE_ASSET__wzFx9FM9__"